import React, { useState } from 'react'
import styles from './profilebody.module.css';
import EditShipping from '../addEditAddress/EditShipping';
import AddShipping from '../addEditAddress/AddShipping';
import { useParams } from 'react-router-dom';
import AddBilling from '../addEditAddress/AddBilling';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomerEditData } from '../../../../Website/redux/customerSlice';
import AddressTable from './AddressTable';

const ShippingAddress = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const [isAddShipPopupOpen, setAddShipPopupOpen] = useState(false);
    const [isEditShipPopupOpen, setEditShipPopupOpen] = useState(false);
    const { customer } = useSelector((state) => state.customer)



    const openAddShipPopup = () => {
        dispatch(setCustomerEditData({}))
        setAddShipPopupOpen(true);
    };

    const handleEditClick = async (data) => {
        await dispatch(setCustomerEditData(data))
        setEditShipPopupOpen(true)
    }

    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <h2>Shipping Address</h2>
                <button className={styles.savechanges} onClick={openAddShipPopup}>Add New Addres</button>
                {isAddShipPopupOpen && <AddBilling
                    onClose={() => setAddShipPopupOpen(false)}
                    heading={'Add New Shipping Address'}
                    from="csa"
                    parent="shipping"
                />
                }
            </div>
            <div className={styles.profilebodyContent}>
                <div className={styles.address_container}>

                    {customer?.shippingAddress?.length > 0 ?
                        <>
                            <AddressTable
                                heading="Shipping"
                                customer={customer}
                                addressData={customer?.shippingAddress}
                                handleEditClick={handleEditClick}

                            />
                            {isEditShipPopupOpen &&
                                <AddBilling
                                    onClose={() => setEditShipPopupOpen(false)}
                                    heading={'Edit New Billing Address'}
                                    from="cbe"
                                    parent="shipping"
                                />
                            }
                        </>
                        :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>No Address found</div>
                    }

                </div>
            </div>
        </div>
    )
}

export default ShippingAddress